import type { api } from '../../api/client';

export const ROLES = [
  { value: 'admin', label: '管理員 admin' },
  { value: 'editor', label: '主編 editor' },
  { value: 'author', label: '記者 author' },
  { value: 'viewer', label: '檢視者 viewer' },
];
export const PROVIDER_COLOR: Record<string, string> = { line: 'green', google: 'blue', yahoo: 'purple' };

/** 帳號管理列表的一筆使用者 */
export type ManagedUser = Awaited<ReturnType<typeof api.usersManage>>[number];
